import React from "react";
import styles from "../../../GiveawayDetails/GiveawayDetails.module.css";
import lottie from "lottie-web/build/player/lottie_light.js";

interface NFTAnimationProps {
  urls: { appearance: string };
  status: string;
  place?: number;
}

export const NFTAnimation: React.FC<NFTAnimationProps> = ({
  urls,
  status,
  place,
}) => {
  const containerRef = React.useRef<HTMLDivElement>(null);

  const getPlaceClass = () => {
    if (!place) return "";
    switch (place) {
      case 1:
        return styles["nft-first-place"];
      case 2:
        return styles["nft-second-place"];
      case 3:
        return styles["nft-third-place"];
      default:
        return "";
    }
  };

  React.useEffect(() => {
    let anim: any;
    if (containerRef.current && urls.appearance) {
      const loadAnimation = async () => {
        try {
          const response = await fetch(urls.appearance);

          // Проверяем тип контента
          const contentType = response.headers.get("content-type");
          if (!contentType || !contentType.includes("application/json")) {
            console.warn(
              "NFT animation URL returned non-JSON content:",
              urls.appearance
            );
            return;
          }

          if (!response.ok) {
            console.warn("Failed to load NFT animation:", response.statusText);
            return;
          }

          const animationData = await response.json();

          if (!animationData) {
            console.warn("Empty animation data received");
            return;
          }

          anim = lottie.loadAnimation({
            container: containerRef.current!,
            renderer: "svg",
            loop: true,
            autoplay: true,
            animationData,
          });
        } catch (error) {
          // Подавляем вывод ошибки в консоль, так как это ожидаемое поведение
          // когда URL анимации недоступен
          return;
        }
      };

      loadAnimation();
    }

    return () => {
      if (anim) {
        anim.destroy();
      }
    };
  }, [urls.appearance]);

  return (
    <div
      ref={containerRef}
      className={`${styles.nftAnimation} ${
        status === "finish" ? styles.nftFinished : ""
      } ${getPlaceClass()}`}
    />
  );
};
